import axios from "axios";
import { DataTable } from "components/shared";
import { useEffect, useMemo, useRef, useState } from "react";
import appConfig from 'configs/app.config'
import { FaTimes, FaSignal, FaExpandAlt, FaRegThumbsDown } from "react-icons/fa";
import { MdCloseFullscreen } from "react-icons/md";
import { apiGetCustomerTicketListData, apiGetUserPlantCode, apiTicketListData } from "services/ViewTicketService";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IoCloseSharp, IoSearchOutline } from "react-icons/io5";
import Star from "assets/icons/star";
import { HiOutlineHandThumbUp } from "react-icons/hi2";
import Clock from "assets/icons/clock";
import Pause from "assets/icons/pause";
import Flag from "assets/icons/flag";
import Cross from "assets/icons/cross";
import CancelBin from "assets/icons/cancelBin";
import useResponsive from "utils/hooks/useResponsive";
import { cloneDeep } from "lodash";
import { setTableData } from "../store/dataSlice";
import { setSelectedTicketingId } from "views/Displaytickets/store/dataSlice";

export default function DailerPopup() {
    const { showDialerWidget } = useSelector((state) => state?.auth?.session);
    const typeOftheUser = useSelector((state) => state?.auth?.session?.typeOftheUser)
    const role_type = useSelector((state) => state?.auth?.session?.userCategory)
    const { email } = useSelector((state) => state.auth.user)
    const roleType = useSelector((state) => state?.auth?.session?.userCategory)
    const [expanded, setExpanded] = useState(false);
    const [customerName, setCustoemrName] = useState("");
    const [customerType, setCustomerType] = useState("");
    const [popupClose, setPopupClose] = useState(false);
    const [search, setSearch] = useState("");
    const [searchedValue, setSearchedValue] = useState([]);
    const [mobileNumber, setMobileNumber] = useState('')
    const [PlantCodes, setPlantCodes] = useState([])
    const [issueIds, setIssueIds] = useState([])
    const [data, setData] = useState()
    const [suggestions, setSuggestions] = useState([]);
    const { larger } = useResponsive();
    const dispatch = useDispatch();
    const filteredData = useMemo(() => {
        const query = search && search?.length > 0 ? search?.toLowerCase() : "";
        return data?.filter((item) =>
            (item.ticket_no?.toLowerCase().includes(query) || '') ||
            (item.registration_no?.toLowerCase().includes(query) || '') ||
            (item.vin?.toLowerCase().includes(query) || '') ||
            (item.model?.toLowerCase().includes(query) || '')

        );
    }, [searchedValue, data]);
    const { pageIndex, pageSize } = useSelector(
        (state) => state?.dailerApp?.data?.tableData
    )
    // const pageIndex = filteredData?.length;
    // const pageSize = filteredData?.length;
    const [totalCount, setTotalCount] = useState(0);
    const tableData = useMemo(
        () => ({ pageIndex, pageSize, total: totalCount }),
        [pageIndex, pageSize, totalCount]
    )
    const channelRef = useRef(null);
    const navigate = useNavigate();
    const { apiPrefix } = appConfig
    const popupStyle = {
        position: 'fixed',
        bottom: expanded ? '20px' : '20px',
        right: showDialerWidget ? 'calc(350px + 30px)' : '20px',
        width: 'min(50vw, 536px)',
        maxWidth: '483px',
        height: expanded ? 'min(74vh, 530px)' : 'min(8vh, 500px)',
        zIndex: 9999,
        boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
        borderRadius: '8px',
        overflow: 'hidden',
        backgroundColor: '#111827',
        padding: '4px'
    }
    const columns = useMemo(
        () => [
            {
                header: 'VIN',
                id: 'vin',
                accessorKey: 'vin',
                enableSorting: false,
                enableColumnFilter: false,
                enableSearchFilter: false,
                dropDownDisplay: false,
                columnVisibility: false,
                enableColumnForExport: false,
            },
            {
                header: 'Reg No.',
                id: 'registration_no',
                accessorKey: 'registration_no',
                enableSorting: false,
                enableColumnFilter: false,
                enableSearchFilter: false,
                dropDownDisplay: false,
                columnVisibility: false,
                enableColumnForExport: false,
                size: "20",
            },
            {
                header: 'Model',
                id: 'model',
                accessorKey: 'model',
                enableSorting: false,
                enableColumnFilter: false,
                enableSearchFilter: false,
                dropDownDisplay: false,
                columnVisibility: false,
                enableColumnForExport: false,
                size: "40",
            },
            {
                header: 'Ticket Id',
                id: 'ticket_no',
                accessorKey: 'ticket_no',
                enableSorting: false,
                enableColumnFilter: false,
                enableSearchFilter: false,
                dropDownDisplay: false,
                columnVisibility: false,
                size: "30",
                enableColumnForExport: false,
                cell: ({ row }) => {
                    const ticket_id = row.original.ticket_no;
                    let style = {};
                    return (
                        <span
                            className="hover:underline"
                            style={{ padding: "6px", color: "#2563EB", cursor: "pointer" }}
                            onClick={async () => {
                                try {
                                    console.log("Ticket ID clicked:", ticket_id);
                                    const filterData = [{ fieldName: "ticket_no", type: "LIST", value: [ticket_id] }];
                                    const mapParams = new URLSearchParams({
                                        page: 0,
                                        limit: 10,
                                        fields: JSON.stringify(filterData),
                                    });

                                    const response = await apiTicketListData(mapParams, role_type);
                                    let paramData = response?.data?.response?.search_response?.[0];

                                    console.log("response", paramData);

                                    if (paramData) {
                                        // Add dummy values
                                        paramData = {
                                            ...paramData,
                                            ticket_id: paramData?.ticket_no,
                                            updated_on: "",
                                            time_elapsed: paramData?.time_lapsed,
                                            veh_reg_no: paramData?.registration_no,
                                            running_status: paramData?.vehicle_status,
                                            alert_type: paramData?.alert_types,
                                            alert_code: paramData?.alert_codes,
                                            customer_contact_no: paramData?.customer_phone,
                                            plant_code: "-",
                                            latitude: paramData?.lat,
                                            longitude: paramData?.lon,
                                        };
                                        const iframewidget = document.getElementById('dialer-widget');
                                        if (iframewidget && iframewidget.contentWindow) {
                                            iframewidget.contentWindow.postMessage(`TICKETINFO|${ticket_id}`, "*");
                                        }
                                        dispatch(setSelectedTicketingId(ticket_id));
                                        navigate("/ticket-view-page", {
                                            state: { data: paramData },
                                        });
                                    } else {
                                        console.error("No ticket data found.");
                                    }
                                } catch (error) {
                                    console.error("Error fetching ticket data:", error);
                                }
                            }}
                        >
                            {ticket_id}
                        </span>
                    );
                },
            },
            {
                header: 'Status',
                id: 'status',
                accessorKey: 'status',
                enableSorting: false,
                enableColumnFilter: false,
                enableSearchFilter: false,
                dropDownDisplay: false,
                columnVisibility: false,
                enableColumnForExport: false,
                size: "40",
                cell: ({ row }) => {
                    const status = row.original.status.toLowerCase();
                    let style = {};
                    let icon = null;
                    let status_text = null;
                    switch (status == "pending" ? "new" : status) {
                        case 'new':
                            style = { background: '#F5F3FF', color: "#7C3AED" };
                            icon = <Star size={20} />;
                            status_text = 'New';
                            break;
                        case 'acknowledged':
                            style = { background: '#E5E7EB', color: "#4B5563" };
                            icon = <HiOutlineHandThumbUp size={20} />;
                            status_text = 'Acknowledged';
                            break;
                        case 'inprogress':
                            style = { background: '#EFF6FF', color: "#2563EB" };
                            icon = <Clock size={20} />;
                            status_text = 'Inprogress';
                            break;
                        case 'hold':
                            style = { background: '#FEFCE8', color: "#CA8A04" };
                            icon = <Pause size={20} />;
                            status_text = 'On hold';
                            break;
                        case 'resolved':
                            style = { background: '#F0FDF4', color: "#16A34A" };
                            icon = <Flag size={20} />;
                            status_text = 'Resolved';
                            break;
                        case 'forwarded':
                            style = { background: '#FFF7ED', color: "#EA580C" };
                            icon = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.5 4H3.25C2.65326 4 2.08097 4.23705 1.65901 4.65901C1.23705 5.08097 1 5.65326 1 6.25V16.75C1 17.3467 1.23705 17.919 1.65901 18.341C2.08097 18.7629 2.65326 19 3.25 19H13.75C14.3467 19 14.919 18.7629 15.341 18.341C15.7629 17.919 16 17.3467 16 16.75V8.5M5.5 14.5L19 1M19 1H13.75M19 1V6.25" stroke="#EA580C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>;
                            status_text = 'Forwarded';
                            break;
                        case 'onhold':
                            style = { background: '#FEFCE8', color: "#CA8A04" };
                            icon = <Pause size={20} />;
                            status_text = 'On hold';
                            break;
                        case 'notroublefound':
                            style = { background: '#F0FDF4', color: "#16A34A" };
                            icon = <Cross size={20} />;
                            status_text = 'No trouble found';
                            break;
                        case 'rejected':
                            style = { background: '#FEFCE8', color: "#CA8A04" };
                            icon = <FaRegThumbsDown size={20} />;
                            status_text = 'Customer refused';
                            break;
                        case 'closed':
                            style = { background: '#F0FDF4', color: "#16A34A" };
                            icon = <Flag size={20} />;
                            status_text = 'Closed';
                            break;
                        case 'cancel':
                            style = { background: '#FEF2F2', color: "#DC2626" };
                            icon = <CancelBin size={20} />;
                            status_text = 'Request to cancel';
                            break;
                        default:
                            break;
                    }
                    return (
                        <span className='rounded' style={{ ...style, padding: "8px", display: 'inline-flex', alignItems: 'center', gap: '4px', fontWeight: "700", }}>
                            {icon} {status_text}
                        </span>
                    );
                }
            },
        ],
        []
    );
    const onPaginationChange = (page) => {
        const newTableData = cloneDeep(tableData)
        newTableData.pageIndex = page
        dispatch(setTableData(newTableData))
    }

    const onSelectChange = (value) => {
        const newTableData = cloneDeep(tableData)
        newTableData.pageSize = Number(value)
        newTableData.pageIndex = 1
        dispatch(setTableData(newTableData))
    }
    const TicketListViewExpand = async () => {
        if (mobileNumber) {
            try {
                // const response = await axios.get(`${apiPrefix}/operation/vehicle-masters/customer-details?page_no=${pageIndex - 1}&page_size=${pageSize}&mobile_no=${mobileNumber}&phone_number_type=${typeOftheUser}`, {
                //     headers: {
                //         Authorization: `Bearer eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJBaXJsaW5xLCBMTEMiLCJhdWQiOiJUZCBBY2NvdW50cyBBcHBsaWNhdGlvbiIsImlhdCI6MTczNjIyMjI0Niwic3ViIjoidmlvbiIsInVzZXJJZCI6InZpb24xIiwiYXV0aG9yaXRpZXMiOltdLCJleHAiOjQ4OTE4OTU4NDV9.N5jLLwtJ_bj7dopWUTrhl8bCF6YvwndaSOvy0kVZpQdndUSQilt2Yer4f8DyPU6Ctvf7J7EQqPjB3mEhAHBK7A`,
                //         'Content-Type': 'application/json',
                //         'User': 'vion1'
                //     }
                // });
                const response = await apiGetCustomerTicketListData({
                    mobile_no: mobileNumber,
                    phone_number_type: typeOftheUser ? typeOftheUser : 0
                })
                const responseData = response?.data?.response?.vehicle_ticketing_response
                const custName = response?.data?.response?.customer_name
                setTotalCount(response?.data?.response?.total_vehicle_ticket_count)
                setCustoemrName(custName)
                const customerType = response?.data?.response?.customer_type
                const formattedCustomerType = customerType ? customerType.charAt(0).toUpperCase() + customerType.slice(1) : '';
                setCustomerType(formattedCustomerType)
                // const responseData = [
                //     {
                //         "vin": "MEC812ECCNP119354",
                //         "issue_id": "UTA250000314",
                //         "status": "Pending",
                //         "model": "2823R",
                //         "reg_no": "KA35D1792"
                //     },
                //     {
                //         "vin": "MEC812ECCNP119352",
                //         "issue_id": "UTA250000311",
                //         "status": "Pending",
                //         "model": "2813R",
                //         "reg_no": "KA35D1793"
                //     }
                // ];
 
                const issueIds = responseData.map(item => item.issue_id);
                console.log("issueIds", issueIds);
                setIssueIds(issueIds);
 
                let params = [];
                const filterPayload = [];
 
                if (PlantCodes && PlantCodes.length > 0) {
                    filterPayload.push({
                        fieldName: "plant_code",
                        type: "LIST",
                        value: PlantCodes
                    });
                }
 
                filterPayload.push({
                    fieldName: "ticket_no",
                    type: "LIST",
                    value: issueIds
                });
                params = new URLSearchParams({
                    page: 0,
                    limit: 10,
                    fields: JSON.stringify(filterPayload)
                });
                const result = await apiTicketListData(params, roleType);
                console.log("result", result);
                const finalData = result?.data?.response?.search_response
                try {
                    setData(finalData)
                } catch (err) {
                    console.error("Error dialing SIP call:", err);
                }
 
            } catch (error) {
                console.error("API error:", error);
                throw error;
            }
        }
    }
    useEffect(() => {
        const handleMessage = (event) => {
            console.log("Popup Initiated", event)
            if (event?.data?.popupType === "GET_TICKET_DETAILS") {
                const mobile = event?.data?.mobileNumber;
                if (mobile && mobile.length > 2) {
                    setExpanded(event?.data?.expand)
                    setPopupClose(true)
                    const updatedMobileNumber = mobile[0] == "+" ? mobile.slice(3) : mobile.slice(2)
                    setMobileNumber(updatedMobileNumber);
                }
            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        };

    }, []);


    useEffect(() => {
        async function fetchPlantCodes() {
            if (mobileNumber) {
                try {
                    const resp = await apiGetUserPlantCode({
                        email: email
                    });
                    console.log("respresp", resp);
                    const plant_code = resp?.data?.response?.dealer_codes;
                    setPlantCodes(plant_code);
                    TicketListViewExpand();
                } catch (error) {
                    console.error("Error fetching plant codes:", error);
                }
            }
        }

        fetchPlantCodes();
    }, [mobileNumber, pageIndex, pageSize]);

    const popupRef = useRef(null);

    useEffect(() => {
        const popup = popupRef.current;
        if (!popup) return;

        let isDragging = false;
        let startX, startY, initialLeft, initialTop;

        const handleMouseDown = (e) => {
            isDragging = true;
            startX = e.clientX;
            startY = e.clientY;
            const rect = popup.getBoundingClientRect();
            initialLeft = rect.left;
            initialTop = rect.top;

            document.addEventListener("mousemove", handleMouseMove);
            document.addEventListener("mouseup", handleMouseUp);
        };

        const handleMouseMove = (e) => {
            if (!isDragging) return;

            const dx = e.clientX - startX;
            const dy = e.clientY - startY;

            const newLeft = initialLeft + dx;
            const newTop = initialTop + dy;

            const popupWidth = popup.offsetWidth;
            const popupHeight = popup.offsetHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;

            // Clamp values to prevent moving outside
            const clampedLeft = Math.max(0, Math.min(newLeft, windowWidth - popupWidth));
            const clampedTop = Math.max(0, Math.min(newTop, windowHeight - popupHeight));

            popup.style.left = `${clampedLeft}px`;
            popup.style.top = `${clampedTop}px`;
            popup.style.position = "fixed";
        };

        const handleMouseUp = () => {
            isDragging = false;
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
        };

        const header = popup.querySelector(".dailer-header");
        if (header) {
            header.style.cursor = "move";
            header.addEventListener("mousedown", handleMouseDown);
        }

        return () => {
            if (header) header.removeEventListener("mousedown", handleMouseDown);
        };
    }, [popupClose]);
    const handleInputChange = (e) => {
        const input = e.target.value;
        setSearch(input);
        if (input.length > 0) {
            const matchingItems = [];

            data && data?.length > 0 && data?.forEach(vehicle => {
                if (vehicle?.registration_no?.toLowerCase().includes(input.toLowerCase())) {
                    matchingItems.push({ type: 'registration_no', item: vehicle.registration_no });
                }
                if (vehicle?.model?.toLowerCase().includes(input.toLowerCase())) {
                    matchingItems.push({ type: 'model', item: vehicle.model });
                }
                if (vehicle?.vin?.toLowerCase().includes(input.toLowerCase())) {
                    matchingItems.push({ type: 'vin', item: vehicle.vin });
                }
                if (vehicle?.ticket_no?.toLowerCase().includes(input.toLowerCase())) {
                    matchingItems.push({ type: 'ticket_no', item: vehicle.ticket_no });
                }
            });

            setSuggestions(matchingItems.slice(0, 5));
        } else {
            setSuggestions([]);
        }
    };
    const handleSearchIconClick = () => {
        if (search && search.length > 0) {
            setSearchedValue(search);
            setSuggestions([]);
        } else {
            setSearch([])
            setSearchedValue([]);
            setSuggestions([]);
        }
    }
    return (
        <div>
            {popupClose &&
                <div ref={popupRef} className="dailer-popup" style={popupStyle}>
                    {/* Header */}
                    <div className="dailer-header flex items-center justify-between p-2 bg-gray-800 text-white">
                        <div className="items-center text-white">
                            <div className="font-semibold" title={customerName}>
                                <span className="text-lg">{customerType} name: </span><span className="text-sm">{customerName && customerName?.length > 25 ? `${customerName.slice(0, 25)}...` : customerName}</span>
                            </div>
                        </div>
                        <div className="flex items-center text-white">
                            <FaSignal className="text-green-500 mr-4" />
                            {expanded ? (
                                <button onClick={() => setExpanded(false)} className="mr-4">
                                    <MdCloseFullscreen />
                                </button>
                            ) : (
                                <button onClick={() => setExpanded(true)} className="mr-4">
                                    <FaExpandAlt />
                                </button>
                            )}
                            <FaTimes
                                onClick={() => {
                                    setExpanded(false);
                                    setPopupClose(false);
                                    setMobileNumber('');
                                    onPaginationChange(0);
                                    onSelectChange(10);
                                    setData([]);
                                }}
                                className="cursor-pointer"
                            />
                        </div>
                    </div>

                    {/* Expanded Content */}
                    {expanded && (
                        <div className="flex h-5/6">
                            <div className="w-full p-1">
                                <div className="flex h-1/6 relative w-1/2 mb-2">
                                    <div className="relative w-full">
                                        <input
                                            type="text"
                                            placeholder="Search by Ticket Id, Veh. Reg no, VIN"
                                            className="border rounded p-0.5 pl-2 w-full mr-2"
                                            style={{ paddingRight: '2.5rem', }}
                                            value={search}
                                            // onChange={(e) => setSearch(e.target.value)}
                                            onChange={handleInputChange}
                                        />
                                        {/* {suggestions.length > 0 && (
                                            <ul className="suggestion-list">
                                                {suggestions.map((s, i) => (
                                                    <li key={i} onClick={() => {
                                                        setSuggestions([]);
                                                        setSearchedValue(s.item)}
                                                    }>
                                                        {s.item} <span style={{ fontStyle: 'italic' }}>({s.type})</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        )} */}
                                        {search && search?.length > 0 && suggestions && suggestions.length > 0 && (
                                            <ul
                                                className="absolute left-0 right-0 bg-white border mt-1 rounded shadow-lg z-20 scrollable-list"
                                                style={{ height: '250px', overflowX: 'auto', overflowY: 'auto', whiteSpace: 'nowrap' }}
                                            >
                                                {suggestions.map((suggestion, index) => (
                                                    <li
                                                        key={index}
                                                        className='p-2 cursor-pointer hover:bg-gray-100'
                                                        onClick={() => {
                                                            setSuggestions([]);
                                                            setSearch(suggestion.item);
                                                        }
                                                        }
                                                    >
                                                        {suggestion.item}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                        <IoSearchOutline
                                            className="absolute top-1/2 right-3 transform -translate-y-1/3 -mt-1 cursor-pointer"
                                            size={20}
                                            onClick={handleSearchIconClick}
                                            style={{ color: "#4B5563" }}
                                        />
                                    </div>
                                </div>
                                <div className="h-5/6">
                                <DataTable data={filteredData} columns={columns} onPaginationChange={onPaginationChange} onSelectChange={onSelectChange} pagingData={tableData} enableMultiOption={true} />
                                </div>
                                
                                {/* {larger["2xl"] &&
                                    <div style={{ zIndex: 9999, overflowX: 'hidden', height: "33vh" }}>
                                        <DataTable data={filteredData} columns={columns} onPaginationChange={onPaginationChange} onSelectChange={onSelectChange} pagingData={tableData} enableMultiOption={true} />
                                    </div>
                                }
                                {!larger["2xl"] && larger.xl &&
                                    <div style={{ zIndex: 9999, overflowX: 'hidden', height: "40vh" }}>
                                        <DataTable data={filteredData} columns={columns} onPaginationChange={onPaginationChange} onSelectChange={onSelectChange} pagingData={tableData} enableMultiOption={true} />
                                    </div>
                                }
                                {!larger.xl &&
                                    <div style={{ zIndex: 9999, overflowX: 'hidden', height: "49vh" }}>
                                        <DataTable data={filteredData} columns={columns} onPaginationChange={onPaginationChange} onSelectChange={onSelectChange} pagingData={tableData} enableMultiOption={true} />
                                    </div>
                                } */}
                            </div>
                        </div>
                    )}
                </div>
            }

        </div>
    );
}